var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"talentq-finish"},[_c('h3',[_vm._v(_vm._s(_vm.$tr('talentq.finish.title')))]),_vm._v(" "),_c('div',{staticClass:"talentq-finish__text"},[_vm._v("\n    "+_vm._s(_vm.$tr('talentq.finish.text'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }